import { DashboardUtils } from "../../../dashboard_utils";

export function LoadingThrobber(props: {
	loading_text?: string;
	vertical_spaces?: number;
}) {
	return (
		<>
			{DashboardUtils.RenderLoadingThrobber(
				props.loading_text,
				props.vertical_spaces
			)}
		</>
	);
}
